import { Box, Button } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useSounds } from 'contexts/Sounds/Sounds';
import { useMemo } from 'react';
import { MaterialSymbol } from 'react-material-symbols';

const disabledRounds = ['init', 'hole', 'next', 'end'];

export default function FoldButton() {
    const game = useGame();
    const page = usePage();
    const sounds = useSounds();

    const { disableFoldButton, foldButtonLesson, incorrectActionLesson } = game.lessonProps;

    const disabled = useMemo(() => {
        return !foldButtonLesson && (disableFoldButton || disabledRounds.includes(game.round));
    }, [disableFoldButton, foldButtonLesson, game.round]);

    function handleClick() {
        if (!game.loading && game.ready) {
            sounds.play('submit');

            // Perform action
            const incorrect = incorrectActionLesson && game.shouldPay;
            if (incorrect) {
                game.interceptAction('fold', foldButtonLesson);
            } else if (!disableFoldButton) {
                game.fold(!foldButtonLesson);
            }

            // Show lesson
            if (incorrect) {
                page.show(incorrectActionLesson);
            } else if (foldButtonLesson) {
                page.show(foldButtonLesson);
            }
        }
    }

    return (
        <Box marginTop={1} textAlign="center">
            <Button
                disabled={disabled}
                startIcon={<MaterialSymbol aria-hidden icon="delete" size={23} />}
                tabIndex={8}
                variant="text"
                onClick={handleClick}
            >
                Fold
            </Button>
        </Box>
    );
}
